import { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";

const BannerLGPD = () => {

    const theme = useTheme(); // Obtendo o tema do MUI

    const styles = {
        banner: {
            position: "fixed",
            bottom: 0,
            width: "100%",
            background: theme.palette.primary.main,
            color: "#fff",
            padding: "10px 20px",
            textAlign: "center",
            zIndex: 1000,
        },
        container: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
        },
        link: {
            color: "#fff",
            textDecoration: "underline",
        },
        button: {
            padding: "5px 20px",
            marginLeft: "20px",
            background: theme.palette.primary.text,
            
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
        },
    };
    const [aceito, setAceito] = useState(false);

    useEffect(() => {
        // Verifica se o usuário já aceitou os termos
        const termoAceito = localStorage.getItem("termoAceito");
        if (termoAceito) {
            setAceito(true);
        }
    }, []);

    const aceitarTermos = () => {
        // Salva a aceitação no localStorage e esconde o banner
        localStorage.setItem("termoAceito", "true");
        setAceito(true);
    };

    if (aceito) return null; // Se o usuário aceitou, não exibe o banner

    return (
        <div style={styles.banner}>
            <div style={styles.container}>
                <p>
                    Ao navegar neste site, você aceita os{" "}
                    <strong>
                        <a
                            href="/TermosPrivacidade"
                            style={styles.link}
                            rel="noopener noreferrer"
                        >
                            Termos de Privacidade
                        </a>
                    </strong>{" "}
                    que usamos para melhorar sua experiência.
                </p>
                <button onClick={aceitarTermos} style={styles.button}>
                    Entendi!
                </button>
            </div>
        </div>
    );
};

export default BannerLGPD;
